import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';

import { UserRepository, User } from 'app/user';
import { NotifyService, ToastType } from 'app/notify';
import { UserImport } from '../user-import.model';
import { UserGroupId } from 'app/group/user-group.model';

@Component({
  selector: 'app-user-import',
  templateUrl: './user-import.component.html',
  styleUrls: ['./user-import.component.scss']
})
export class UserImportComponent {

  public excelId: string = null;
  public groupId: UserGroupId = null;
  public usersImport: UserImport[] = [];

  constructor(
    activatedRoute: ActivatedRoute,
    private userRepository: UserRepository,
    private notify: NotifyService,
    private translateService: TranslateService,
    private router: Router
  ) {
    if (activatedRoute.snapshot.params['excelId'] !== undefined) {
      this.excelId = activatedRoute.snapshot.params['excelId'];
      this.loadUserList(this.excelId);
    }

    if (activatedRoute.snapshot.params['groupId'] !== undefined) {
      this.groupId = activatedRoute.snapshot.params['groupId'];
    }
  }

  public isImportDataValid(): boolean {
    for (const userImport of this.usersImport) {
      if (Object.keys(userImport.errors).length !== 0) {

        return false;
      }
    }

    return true;
  }

  private loadUserList(excelId: string) {
    this.userRepository.returnListOfImportedUsers(excelId).subscribe(
      (usersList: UserImport[]): void => {
        this.usersImport = usersList;
      }
    );
  }

  private acceptImport(excelId: string) {
    this.userRepository.importUsersToDatabase(excelId, this.groupId).subscribe(
      (): void => {
        if (this.groupId !== null) {
          this.router.navigate(['group', this.groupId, 'edit']);
        } else {
          this.router.navigate(['participant', 'list']);
        }

        this.notify.toast(ToastType.SUCCESS, this.translateService.instant('uploader.success_import_users'));
      }
    );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/import/user-import/user-import.component.ts